import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { BrowserAuthError, InteractionRequiredAuthError } from "@azure/msal-browser";
import { AlertController, LoadingController } from "@ionic/angular";
import { nextTick } from "node:process";
import { from, Observable, of, Subject, throwError } from "rxjs";
import { catchError, concatMap, delay, mergeMap, retryWhen, switchMap } from "rxjs/operators";
import { environment } from "src/environments/environment";

import { AuthenticationService } from "./authentication.service";

@Injectable()
export class SessionRecoveryInterceptor implements HttpInterceptor {
    private authToken: string;
    private count = 1;

    private retry = {
        count: 2,
        delay: 100,
        status: [401, 403]
    };

    constructor(private authService: AuthenticationService,
        private loadingController: LoadingController,
        private msal: MsalService,
        private alertController: AlertController) {
    }


    // intercept(
    //     request: HttpRequest<unknown>,
    //     next: HttpHandler
    // ): Observable<HttpEvent<unknown>> {
    //     return next.handle(this.updateHeader(request)).pipe(
    //         retryWhen(error =>
    //             error.pipe(
    //                 concatMap((error, count) => this.retryContent(error, count, request, next)),
    //                 delay(this.retry.delay)
    //             )
    //         )
    //     );
    // }

    private _refreshSubject: Subject<any> = new Subject<any>();

    private _ifTokenExpired() {
        this._refreshSubject.subscribe({
            complete: () => {
                this._refreshSubject = new Subject<any>();
            }
        });
        if (this._refreshSubject.observers.length === 1) {
            // Hit refresh-token API passing the refresh token stored into the request
            // to get new access token and refresh token pair

            this.authService.refreshToken().subscribe(this._refreshSubject);
        }
        return this._refreshSubject;
    }

    private _checkTokenExpiryErr(error: HttpErrorResponse): boolean {
        return (
            error.status &&
            error.status === 401 &&
            error.error
        );
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.url.endsWith("/logout") || req.url.endsWith("/token-refresh")) {
            return next.handle(req);
        } else {
            return next.handle(req).pipe(
                catchError((error, caught) => {
                    if (error instanceof HttpErrorResponse) {
                        if (this._checkTokenExpiryErr(error)) {
                            return this._ifTokenExpired().pipe(
                                switchMap(() => {
                                    console.log('inside iftoken')
                                    return next.handle(this.updateHeader(req));
                                })
                            );
                        } else {
                            return throwError(error);
                        }
                    }
                    return caught;
                })
            );
        }
    }

    //   updateHeader(req) {
    //     const authToken = this.store.getAccessToken();
    //     req = req.clone({
    //       headers: req.headers.set("Authorization", `Bearer ${authToken}`)
    //     });
    //     return req;
    //   }

    private retryContent(error, count, request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
        console.log('RETRY CALLED');
        debugger;
        if (count < this.retry.count && this.retry.status.includes(error.status)) {
            return from(this.msal.instance.acquireTokenSilent(environment.adalConfig)).pipe(
                mergeMap(data => {
                   // localStorage.setItem('accessToken', 'Bearer ' + data.accessToken);
                    return next.handle(this.updateHeader(request));
                }), catchError(error => {
                    this.hideGlobalLoader();
                    if (error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError) {
                        this.showAlert(error);
                    }
                    return throwError(error); // return error that will trigger the subscriptions `error` block
                }))
        }
        return throwError(error);
    }

    async showAlert(err) {
        const alert = await this.alertController.create({
            header: 'Session!',
            message: 'Session Expired , Please click on Ok to login ',
            buttons: [
                {
                    text: 'OK',
                    handler: () => {
                        if (err instanceof InteractionRequiredAuthError) {
                            this.msal.instance.acquireTokenRedirect(environment.adalConfig);
                        } else if (err instanceof BrowserAuthError) {
                            this.msal.instance.loginRedirect(environment.adalConfig);
                        }
                    }
                }
            ]
        });
        await alert.present();
    }

    updateHeader(req) {
        const authToken = localStorage.getItem('accessToken');
        console.log(localStorage.getItem('accessToken'));
        req = req.clone({
            headers: req.headers.set("Authorization", authToken)
        });
        return req;
    }

    async hideGlobalLoader() {
        try {
            const element = await this.loadingController.getTop();
            if (element != null) {
                this.loadingController.dismiss();
                return;
            }
        } catch (error) {
        }
    }
}